"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEscolaridade = void 0;
var EEscolaridade;
(function (EEscolaridade) {
    EEscolaridade["Nenhum"] = "";
    EEscolaridade["Fundamental Incompleto"] = "1";
    EEscolaridade["Fundamental Completo"] = "2";
    EEscolaridade["Ensino M\u00E9dio Completo"] = "3";
    EEscolaridade["Ensino M\u00E9dio Incompleto"] = "4";
    EEscolaridade["Ensino M\u00E9dio T\u00E9cnico"] = "5";
    EEscolaridade["Ensino T\u00E9cnico Superior"] = "6";
    EEscolaridade["Ensino Superior Completo"] = "7";
    EEscolaridade["Ensino Superior Incompleto"] = "8";
    EEscolaridade["P\u00F3s-Gradua\u00E7\u00E3o"] = "9";
    EEscolaridade["Mestrado"] = "10";
    EEscolaridade["P\u00F3s-Mestrado"] = "11";
    EEscolaridade["Doutorado"] = "12";
})(EEscolaridade = exports.EEscolaridade || (exports.EEscolaridade = {}));
